import { PageHeader, Card } from "@/components/dash";
import { ShieldCheck, Percent, Server } from "lucide-react";

export default function AdminSettings() {
  return (
    <div>
      <PageHeader title="Ayarlar & Güvenlik" desc="Platform yapılandırması ve güvenlik durumu." />
      <div className="grid sm:grid-cols-2 gap-4">
        <Card className="p-6">
          <div className="flex items-center gap-2"><Percent size={18} className="text-primary" /><h3 className="text-base font-bold">Platform Komisyonu</h3></div>
          <p className="mt-2 text-sm text-muted-foreground">Başarılı işlemlerden %1 platform hizmet komisyonu tahsil edilir. Bekleyen, başarısız veya süresi dolan işlemlerden komisyon alınmaz.</p>
        </Card>
        <Card className="p-6">
          <div className="flex items-center gap-2"><Server size={18} className="text-primary" /><h3 className="text-base font-bold">Ödeme Sağlayıcı</h3></div>
          <p className="mt-2 text-sm text-muted-foreground">NOWPayments entegrasyonu aktif. API ve IPN anahtarları yalnızca backend ortamında güvenli şekilde saklanır.</p>
        </Card>
        <Card className="p-6 sm:col-span-2">
          <div className="flex items-center gap-2"><ShieldCheck size={18} className="text-primary" /><h3 className="text-base font-bold">Güvenlik Durumu</h3></div>
          <ul className="mt-3 grid sm:grid-cols-2 gap-2 text-sm">
            {["JWT + httpOnly cookie oturum", "bcrypt şifre hashleme", "2FA (TOTP) desteği", "Webhook imza doğrulama", "Rate limiting (giriş & payout)", "RBAC rol tabanlı erişim", "Audit log kayıtları", "Idempotent ödeme işleme"].map((x) => (
              <li key={x} className="flex items-center gap-2 text-muted-foreground"><span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> {x}</li>
            ))}
          </ul>
        </Card>
      </div>
    </div>
  );
}
